// OP-3617 — Filtro de status vindo da URL (`?status=`): é como o Hoje aponta
// para uma lista já filtrada. Só vale um valor que a lista conheça; fora
// disso, a lista abre como sempre.

export interface LeitorDeParametros { get(nome: string): string | null }

export function statusDaUrl<T extends string>(params: LeitorDeParametros, validos: readonly T[]): T | null {
  const v = String(params.get('status') ?? '').trim().toUpperCase()
  return v && validos.indexOf(v as T) >= 0 ? (v as T) : null
}
